module.exports = __webpack_public_path__ + "static/media/battery-quarter.8933bccc.svg";